
export type CheckSubscriptionStatus200 = {
  expiresAt?: string;
  hasActiveSubscription?: boolean;
  planId?: string;
  source?: string;
  status?: string;
  subscriptionId?: string;
  success?: boolean;
};
